<template>
	<div class="gallery-table">
		<GalleryTableImage v-for="entry in images" :key="entry.id" :url="entry.url" />
	</div>
</template>

<script lang="ts">
import GalleryTableImage from "@/views/page/GalleryPreview/GalleryTable/GalleryTableImage.vue";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
	name: "GalleryTable",
	components: { GalleryTableImage },

	props: {
		images: {
			type: Object as PropType<{ id: string; url: string }[]>,
			required: true
		}
	}
});
</script>

<style lang="scss" scoped>
.gallery-table {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 15px;

	@media only screen and (max-width: 380px) {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
